import { humanizeName, CALC_KIND_BADGE_COLORS } from "../../utils/rateConditions";
import ConditionPreview from "../ConditionPreview";

export default function ConditionsSummary({ conditions, places, onEdit, editable }) {
  if (conditions.length === 0) {
    return (
      <section className="card summary-card">
        <header className="summary-header">
          <h3>Condiciones tarifarias</h3>
          {editable && (
            <button
              type="button"
              className="summary-edit"
              onClick={onEdit}
            >
              Editar condiciones
            </button>
          )}
        </header>
          No se han definido condiciones especiales.
      </section>
    );
  }

  return (
    <section className="card summary-card">
      <header className="summary-header">
        <h3>Condiciones tarifarias</h3>
        {editable && (
          <button
            type="button"
            className="summary-edit"
            onClick={onEdit}
          >
            Editar condiciones
          </button>
        )}
      </header>

      <div className="summary-list">
        {conditions.map(c => (
          <div key={c.id} className="condition-card">
            <div className="condition-header">
              <strong>{humanizeName(c.name)}</strong>

              <span
                className={`badge ${CALC_KIND_BADGE_COLORS[c.type]}`}
              >
                {badgeByType(c.type)}
              </span>
            </div>

            <div className="concept-summary">
              <ConditionPreview
                condition={c}
                places={places}
              />
            </div>

          </div>
        ))}
      </div>
    </section>
  );
}

function badgeByType(type) {
  switch (type) {
    case "TIME_RANGE": return "Horario";
    case "DAY_KIND": return "Día";
    case "ROUTE_ORIGIN": return "Origen";
    case "ROUTE_DESTINATION": return "Destino";
    case "ROUTE_PASSES_THROUGH": return "Zona";
    case "EXEMPTION": return "Excepción";
    default: return type;
  }
}
